// @flow
import buildColor from "@fdr/static-ui/ColorPalette";
import styled from "styled-components";
import { elevations } from "@fdr/static-ui/Elevations";

export const WagerTypesContainer = styled.section`
  position: sticky;
  z-index: 20;
  top: ${(props) => {
    const defaultValue = props.isURP ? 104 : 107;
    if (props.withVideo) {
      return `${props.fixedOffset}px`;
    }
    if (props.withFixedBanner) {
      return `${defaultValue + 34}px`;
    }
    return `${defaultValue}px`;
  }};
  box-shadow: ${(props) => (props.hasShadow ? elevations.low : "none")};
  border-bottom: 1px solid ${buildColor("grey", "L2")};
`;

export const WagerTypesScroll = styled.ul`
  width: 100%;
  height: 66px;
  position: relative;
  z-index: 1;
  display: flex;
  overflow: auto;
  background-color: white;
  flex-flow: row nowrap;
  padding: 0 16px;
`;
